import { render, staticRenderFns } from "./SaaSIndex.vue?vue&type=template&id=bc2e7228&scoped=true"
import script from "./SaaSIndex.vue?vue&type=script&lang=js"
export * from "./SaaSIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2e7228",
  null
  
)

export default component.exports